import { PropsWithChildren, StrictMode } from "react"
import { Header } from "common/components/Header"
import { Footer } from "common/components/Footer"
import { SubscribedNewslettersContext } from "modules/newsletters/contexts"

export const NewsletterContent = ({ children }: PropsWithChildren<{}>) => (
  <main id="main-content" tabIndex={-1} className="tc-container container mx-auto my-5">
    {children}
  </main>
)
export const Layout = ({ children }: PropsWithChildren<{}>) => {
  const currentYear = new Date().getFullYear()

  return (
    <StrictMode>
      <SubscribedNewslettersContext>
        <div className="flex h-screen flex-col">
          <Header />
          <NewsletterContent>{children}</NewsletterContent>
          <Footer year={currentYear} />
        </div>
      </SubscribedNewslettersContext>
    </StrictMode>
  )
}
